import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-data-lock-config',
  templateUrl: './data-lock-config.component.html',
  styleUrls: ['./data-lock-config.component.css']
})
export class DataLockConfigComponent implements OnInit {
  respConfig: any;
  configData: any;
  configVal=[];
  vall=[];
  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	const data = {"configType":"DATA-LOCK-CONFIG"}
	this._rest.getSettingsData(data).subscribe((res) => {
        this.respConfig = res;
    	if(this.respConfig.error==0){ 
    		this.configData = this.respConfig.resp;
    		var ss=[]; 
    		for(var ii=0;ii<this.configData.length;ii++){
    			var c = this.configData[ii].KeyValue;	
    			this.configVal.push(c);
    		}
    	}   
    	console.log(res);
	});
  }
  updateConfig(keyIndex,i){
  	var errCounter =0;
  	if(keyIndex=="MONTHLY-LOCK-CONFIG"){
  		if(this.configVal[i]<=0 || this.configVal[i]>28){
  			errCounter++;
  			alert("Please enter the value of 1 to 28");
  		}
  	} else if(this.configVal[i]==0){
  		errCounter++;
  		alert("Please enter the value greater than 0");
  	}

  	if(errCounter==0){
  		const data = {"keyIndex":keyIndex, "keyValue":this.configVal[i]};
  		this._rest.updateSettingsData(data).subscribe((res) => {
  			alert("Locking Data has been updated.");
  		});
  	}
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

}
